var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var _window = window;
// 是
var Log = /** @class */ (function () {
    function Log() {
    }
    Log.debug = function () {
        var _a;
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        try {
            _window.log ? (_a = _window.log).debug.apply(_a, data) : console.debug.apply(console, data);
        }
        catch (e) {
            Log.error('日志发生错误', 'debug', data);
        }
    };
    Log.log = function () {
        var _a;
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        try {
            _window.log ? (_a = _window.log).info.apply(_a, data) : console.log.apply(console, data);
        }
        catch (e) {
            Log.error('日志发生错误', 'log', data);
        }
    };
    Log.warn = function () {
        var _a;
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        try {
            _window.log ? (_a = _window.log).warn.apply(_a, data) : console.warn.apply(console, data);
        }
        catch (e) {
            Log.error('日志发生错误', 'warn', data);
        }
    };
    Log.error = function () {
        var _a;
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        try {
            _window.log ? (_a = _window.log).error.apply(_a, data) : console.error.apply(console, data);
        }
        catch (e) {
            console.error('日志发生错误', 'error', data);
        }
    };
    Log.time = function (label) {
        var options = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            options[_i - 1] = arguments[_i];
        }
        var value = {
            time: Date.now(),
            options: options,
        };
        this.sTimeLableMap.set(label, value);
    };
    Log.timeEnd = function (label) {
        var endTime = Date.now(); //  放到前面  减少map查询对结束时间的影响
        var value = Log.sTimeLableMap.get(label);
        if (value !== undefined) {
            var startTime = value.time;
            var times = endTime - startTime;
            // 获取调用客户端的api
            var command = '';
            if (value.options && value.options.length === 3 && value.options[1] === 'clientDatabaseRequest') {
                command = value.options[2];
            }
            Log.log.apply(Log, __spreadArrays(["label: " + label + ": " + times + "ms."], value.options)); // 打印毫秒差
            Log.speedReport(times, command);
            this.sTimeLableMap.delete(label); // 用完了就删掉
        }
        else {
            // Log.error(`no label named ${label} exsit while call timeEnd.`);  // 打印毫秒差
        }
    };
    /**
     * 上报通过jsapi 调用db的时间
     * @param times
     * @param command
     */
    Log.speedReport = function (times, command) {
        command && _window.dbjsApiSpeedReport ? _window.dbjsApiSpeedReport(times, command) : null;
    };
    Log.sTimeLableMap = new Map();
    return Log;
}());
export default Log;
export { Log };
//# sourceMappingURL=Log.js.map